import React, { FC, useMemo } from 'react';
import { compareStrings, nullSafeGet } from '../../utils/DataAccessUtils';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Popover } from 'antd';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { isInternalTech } from '../../utils/AuthUtils';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';

const RequestAdditionalQuotesButton: FC<any> = ({
	quote,
	workOrder,
	currentUser,
	userType,
}): React.ReactElement => {
	const isBuyerManagerOrInternalTech = useMemo(
		() =>
			(userType === ROLE_TYPES.BUYER &&
				currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role))) ||
			isInternalTech(currentUser),
		[userType, currentUser]
	);

	const canShowRequestAdditionalQuotes =
		compareStrings(quote.status, 'declined') || compareStrings(quote.status, 'pending');

	return isBuyerManagerOrInternalTech ? (
		<>
			{nullSafeGet('rfpDataIds.0', workOrder) ? (
				<Link to={`/${userType}/requestsForProposal/detail/${workOrder.rfpDataIds[0]}/details`}>
					<Button>View RFP</Button>
				</Link>
			) : canShowRequestAdditionalQuotes ? (
				<Link
					to={`/${userType}/requestsForProposal/overview/new?workOrderId=${nullSafeGet(
						'id',
						workOrder
					)}`}
				>
					<Popover content="Request quote from other suppliers">
						<Button>Request Additional Quotes</Button>
					</Popover>
				</Link>
			) : null}
		</>
	) : null;
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps)(RequestAdditionalQuotesButton)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
		currentUser: (state as any).session.currentUser,
	}),
	() => ({})
)(ComponentWithoutUserType);
